import { render, staticRenderFns } from "./PageContentContent.vue?vue&type=template&id=706e5624&scoped=true"
import script from "./PageContentContent.vue?vue&type=script&lang=js"
export * from "./PageContentContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e5624",
  null
  
)

export default component.exports